<template>
  <div>
    <v-main>
      <v-form v-model="formValidate">
        <v-container fluid>
          <app-headline title="ตรวจสอบรายการคำขอทำบัตร" />

          <v-row>
            <v-col>
              <v-card
                class="py-6"
                :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
              >
                <!-- px-6 -->
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" lg="auto">
                      <v-select
                        v-model="form.cardType"
                        :items="listCardTypeName"
                        label="ประเภทบัตร"
                        hide-details="auto"
                        outlined
                        dense
                      />
                    </v-col>

                    <v-col cols="12" lg="auto">
                      <v-select
                        v-model="form.cardStatus"
                        :items="listCardStatusName"
                        label="สถานะคำขอ"
                        hide-details="auto"
                        outlined
                        dense
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" lg="auto">
                      <v-text-field
                        v-model="form.firstName"
                        label="ชื่อ"
                        outlined
                        hide-details="auto"
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6" lg="auto">
                      <v-text-field
                        v-model="form.lastName"
                        label="นามสกุล"
                        outlined
                        hide-details="auto"
                        dense
                      ></v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" lg="auto">
                      <v-text-field
                        v-model="form.cardId"
                        label="ID CardReq"
                        outlined
                        hide-details="auto"
                        dense
                      ></v-text-field>
                    </v-col> -->
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" lg="auto">
                      <v-menu
                        v-model="startDateDialog"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        :close-on-content-click="false"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="$dateFormatByLang(form.cardStartDate)"
                            label="ตั้งแต่วันที่"
                            append-icon="mdi-calendar"
                            readonly
                            outlined
                            hide-details="auto"
                            dense
                            v-on="on"
                            @click:append="startDateDialog = true"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="$lang === 'Tha' ? 'th' : 'en'"
                          v-model="form.cardStartDate"
                          @input="startDateDialog = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="6" lg="auto">
                      <v-menu
                        v-model="endDateDialog"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        :close-on-content-click="false"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="$dateFormatByLang(form.cardEndDate)"
                            label="ถึงวันที่"
                            append-icon="mdi-calendar"
                            readonly
                            outlined
                            hide-details="auto"
                            dense
                            v-on="on"
                            @click:append="endDateDialog = true"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :locale="$lang === 'Tha' ? 'th' : 'en'"
                          v-model="form.cardEndDate"
                          @input="endDateDialog = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row v-if="searchValidate" align="center">
                    <v-col>
                      <span class="error--text"
                        >*กรุณาใส่ช่วงเวลาให้ครบถ้วน</span
                      >
                    </v-col>
                  </v-row>
                  <v-row align="center">
                    <v-col cols="auto">
                      <v-btn
                        @click="onSearch"
                        color="primary darken-2"
                        depressed
                        large
                        :disabled="searchValidate"
                      >
                        ค้นหา
                      </v-btn>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn @click="onClear" color="secondary" depressed>
                        ล้าง
                      </v-btn>
                    </v-col>
                    <v-col></v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>

          <app-headline
            :title="'รายการผู้ขอทำบัตร (' + searchCount + ' รายการ)'"
          />

          <v-row>
            <v-col>
              <v-card
                class="py-3"
                :class="{ 'px-6': $vuetify.breakpoint.smAndUp }"
              >
                <req-card-table
                  @search="OnSearchCount"
                  @type="getTypeAndStatus"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-main>
  </div>
</template>

<script>
import ReqCardTable from "@/components/reqcard/ReqCardTable.vue";
export default {
  components: {
    ReqCardTable,
  },
  data() {
    return {
      form: {
        SearchAllStatus: true,
        cardType: "0",
        cardStatus: "2",
        firstName: "",
        lastName: "",
        cardId: "",
        cardStartDate: "",
        cardEndDate: "",
      },
      startDateDialog: false,
      endDateDialog: false,
      formValidate: null,
      DataTable: [],
      listCardTypeName: [],
      listCardStatusName: [],
      searchCount: 0,
      adminStatusObj: {},
    };
  },

  computed: {
    adminRole() {
      return this.adminStatusObj.accessRoleName;
    },

    searchValidate() {
      return !(
        (this.form.cardStartDate === "" && this.form.cardEndDate === "") ||
        (this.form.cardStartDate !== "" && this.form.cardEndDate !== "")
      );
    },
  },

  watch: {
    "$root.$i18n.locale"() {
      this.getTypeAndStatus();
    },
  },

  async mounted() {
    await this.setForm();
    // await this.getTypeAndStatus()
  },

  methods: {
    resetForm() {
      this.$router.replace({ query: null }).catch(() => {
        console.log("same page, same result");
      });
      this.form = {
        SearchAllStatus: true,
        cardType: "0",
        cardStatus: "0",
        firstName: "",
        lastName: "",
        cardId: "",
        cardStartDate: "",
        cardEndDate: "",
      };
    },

    onSearch() {
      this.form.SearchAllStatus = false;
      this.$router.push({ query: this.form }).catch(() => {
        console.log("same page, same result");
      });
    },

    OnSearchCount(count) {
      this.searchCount = count;
    },

    onClear() {
      this.resetForm();

      this.form.SearchAllStatus = true;
    },

    setForm() {
      this.form = { ...this.form, ...this.$route.query };
    },

    async getTypeAndStatus(info) {
      const lang = this.$lang;
      this.listCardStatusName = [
        {
          value: "0",
          text: "ไม่ระบุ",
        },

        ...(info.listCardStatusName.map((item) => {
          return {
            value: item.trreqCardStatusId.toString(),
            text: item[`reqCardStatusFullName${lang}`],
          };
        }) || []),
      ];
      this.listCardTypeName = [
        {
          value: "0",
          text: "ไม่ระบุ",
        },
        ...(info.listCardTypeName.map((item) => {
          return {
            value: item.trreqCardTypeId.toString(),
            text: item[`reqCardTypeFullName${lang}`],
          };
        }) || []),
      ];
      this.adminStatusObj = info.adminStatusObj;
    },
    async apiAdminSearch(payload) {
      try {
        const res = await this.$store.dispatch("reqCard/adminSearch", payload);
        return res.data.data[0];
      } catch (e) {
        console.log(e.response || e);
      }
    },
  },
};
</script>
